import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdvertStatus } from 'src/app/enum/advert-status.enum';
import { Advert } from '@/interfaces/common';
import { AdvertService } from 'services/common';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
})
export class ProductDetailsComponent implements OnInit, OnDestroy {
  //Store Data
  public product?: Advert;
  private id?: number | null;

  //Subscriptions
  private subAdvert: Subscription = Subscription.EMPTY;
  private subParam: Subscription = Subscription.EMPTY;

  public advertStatus = AdvertStatus;

  constructor(
    private advertService: AdvertService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.subParam = this.activatedRoute.paramMap.subscribe(res => {
      this.id = Number(res.get('id'));
      if (this.id) {
        this.getSingleProductById(this.id);
      }
    });
  }

  // TODO: Move this to somewhere. advertService?
  private getSingleProductById(id: number) {
    this.subAdvert = this.advertService.getAdvertByShortId(id).subscribe(
      res => {
        if (res.success && res.data) {
          this.product = {
            ...res.data,
            videoUrl: res.data.user?.isVip ? res.data.videoUrl : undefined,
          };
          if (!this?.product?.images || !this?.product?.images?.length) {
            this.product.images = ['/assets/images/png/fallbackImage.png'];
          }
        }
      },
      err => {
        if (err) {
          console.log(err);
        }
      }
    );
  }

  ngOnDestroy() {
    this.subAdvert.unsubscribe();
    this.subParam.unsubscribe();
  }

  public checkIsActive(): boolean {
    if (!this.product?.expiresAt) return false;
    const currentDate = new Date();
    const expireDate = new Date(this.product.expiresAt);
    return currentDate < expireDate;
  }
}
